import React from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { Filters } from 'styles/pages/browse-catalog/sideBar.js';

const FiltersHeader = ({ resetFilters }) => (
  <Filters>
    <Button
      onClick={() => _.isFunction(resetFilters) && resetFilters()}
      containerStyle={{
        fontSize: '12px',
        border: '1px solid #ccc',
        borderRadius: '50px',
        padding: '1px 5px',
        lineHeight: '1.5',
        textTransform: 'inherit',
        color: 'inherit',
      }}
      startIcon={<RotateLeftIcon />}
      variant='text'
      title='Reset all filters'
    />
  </Filters>
);

export default FiltersHeader;
